module.exports = __webpack_public_path__ + "media/images/agora_techno_logo_mark-df11810cf1d34e7454d1333ec46cc491.png";